import { Button } from "antd";
import styled from "styled-components";
import { ActionButtonType, DictionaryOfBG, DictionaryOfColor } from "./types";

export const ActionButton = styled(Button) <{ actionButtonType?: ActionButtonType }>`
    background-color: ${(props) => DictionaryOfBG[props.actionButtonType ?? ActionButtonType.PRIMARY]};
    color: ${(props) => DictionaryOfColor[props.actionButtonType ?? ActionButtonType.PRIMARY]};

    &:hover {
        color: ${(props) => DictionaryOfColor[props.actionButtonType ?? ActionButtonType.PRIMARY]} !important;
        font-weight: bold !important;
    }
`